import { render, staticRenderFns } from "./ProjectViewClaimIndex.vue?vue&type=template&id=4f7f4b8a&"
import script from "./ProjectViewClaimIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectViewClaimIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports